const localConfig = {
  cognito: {
    redirectUri: 'http://localhost:4001/login'
  },
  recaptchaId: '6Lc0IAcaAAAAACa_mUxjSOX86gDwMvOwkLoi49u3',
  hotjarConfig: { version: 6 }
}

export default localConfig
